module.exports = __webpack_public_path__ + "static/media/protection-epdm.6a13c4f8.png";